import { z } from "zod";
import { QuestionSchema } from "./Question";

export const QuestionRequestSchema = QuestionSchema.pick({
    description: true,
    startDate: true,
    endDate: true,
});

export type QuestionRequest = z.infer<typeof QuestionRequestSchema>;
